module.exports = __webpack_public_path__ + "img/icono-fisica.83f1b190.svg";